var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeasonFw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 854.36 865.71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m648.49 248.39-404.01 418.67",
    fill: "#41788f",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.23 245.85 1.01 114.06",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.2 359.12-112.34 3.96",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.31 232.79-.93 68.52",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660 304.32-65.41-2.54",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "m470.56 543.45 59.59-3.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.14 475.81 10.16 63.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.77 483.52 29.11-52.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.5 404.05 59.23 25.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.31 392.87-35.07-48.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.22 387.92 48.21-42.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.83 384.49-59.69.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.57 450.89-6.96-64.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.62 449.29-34.9 48.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.27 530.7-55.88-32.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.37 529.43 34.16 48.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.69 534.98-49.01 42.05"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m350.07 671.83-5.47-113.93",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.76 563.18 112.1-8.34",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.54 687.08-1.75-68.51",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.11 618.17 65.46-.02",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m730.9 524.51-568.57-123.42",
    fill: "#41788f",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675.06 429.4-96.48 60.85",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m639.72 587.61-62.45-93.46",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m715.67 470.23-58.77 35.25",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689.38 563.72-32.24-56.97",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.79 493.4 94.03-64.56",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.93 333.94 66.05 90.95",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.62 454.2 57.35-37.52",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.24 359.75 34.44 55.67",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.44 743.74-176.73-554.32",
    fill: "#41788f",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587 647.9-100.87-53.25",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.27 696.21 49.83-100.76",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.88 703.46-59.87-33.34",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.75 727.33 33.28-56.37",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.39 280.08 102.87 49.28",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.12 225.77-45.87 102.62",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.32 223.97 61.13 30.99",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.46 196.45-31.06 57.63",
    strokeWidth: 23.83
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeasonFw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Season_FW.7e3a730b8b0daae89cf9ecf5bb000810.svg";